import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData } from './utils';
let DemoColSticky = class DemoColSticky extends LitElement {
    constructor() {
        super(...arguments);
        this.data = getData();
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column width="120">Stock</cds-grid-column>
        <cds-grid-column width="120" position="sticky">Average</cds-grid-column>
        <cds-grid-column width="400">Current</cds-grid-column>
        <cds-grid-column width="400">About</cds-grid-column>
        ${this.data.map(entry => html `
          <cds-grid-row>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer></cds-grid-footer>
      </cds-grid>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoColSticky.prototype, "data", void 0);
DemoColSticky = __decorate([
    customElement('demo-col-sticky')
], DemoColSticky);
export { DemoColSticky };
//# sourceMappingURL=demo.column-sticky.js.map